import { render, staticRenderFns } from "./AvatarSVG.vue?vue&type=template&id=4c94d53d&name=component-name"
import script from "./AvatarSVG.vue?vue&type=script&lang=js"
export * from "./AvatarSVG.vue?vue&type=script&lang=js"
import style0 from "./AvatarSVG.vue?vue&type=style&index=0&id=4c94d53d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports